import { useAudience } from "@/contexts/AudienceContext";

/** "For patients | For GPs" switch shown in the public header. */
export function AudienceToggle({ className = "" }: { className?: string }) {
  const { audience, setAudience } = useAudience();
  return (
    <div className={`ds-seg ${className}`.trim()} role="group" aria-label="Show information for">
      <button type="button" aria-pressed={audience === "public"} onClick={() => setAudience("public")}>
        <span className="ds-seg__long">For patients</span>
        <span className="ds-seg__short">Patients</span>
      </button>
      <button type="button" aria-pressed={audience === "clinician"} onClick={() => setAudience("clinician")}>
        <span className="ds-seg__long">For GPs</span>
        <span className="ds-seg__short">GPs</span>
      </button>
    </div>
  );
}
